<template>
  <router-view>
  </router-view>
</template>

<script>
import { fetchUser, fetchTenant } from './helpers/userMethods';

export default {
  name: 'App',

  methods:{
    fetchUser,
    fetchTenant,
  },

  created(){
    this.fetchUser();
    this.fetchTenant();
  }
}
</script>

<style>
.content {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

header h1 {
  margin: 0 0 8px 0;
}

nav a {
  color: #42b983;
  text-decoration: none;
}

nav a.router-link-exact-active {
  font-weight: bold;
}

main {
  margin-top: 18px;
}
</style>
